// Сетка из 7 категорий с иконками. Без эмодзи — только SVG.
import React from "react";
import { BugIcon } from "../icons/BugIcon";
import { FlagIcon } from "../icons/FlagIcon";
import { UserIcon } from "../icons/UserIcon";
import { WrenchIcon } from "../icons/WrenchIcon";
import { LightBulbIcon } from "../icons/LightBulbIcon";
import { QuestionMarkIcon } from "../icons/QuestionMarkIcon";

// Категория idea специальная: при выборе фронт сразу перенаправит
// юзера на /ideas. Здесь она в списке для полноты выбора.
// Категория «Подписка» убрана 2026-05-25 — подписка живёт на Майнкрафтии,
// для неё своя поддержка через minecraftia-school.ru.
export const CATEGORIES = [
  { id: "bug_player",        label: "Баг в плеере",     Icon: BugIcon },
  { id: "content_complaint", label: "Жалоба на контент", Icon: FlagIcon },
  { id: "account",           label: "Аккаунт",           Icon: UserIcon },
  { id: "service_down",      label: "Сервис недоступен", Icon: WrenchIcon },
  { id: "idea",              label: "Идея",              Icon: LightBulbIcon },
  { id: "other",             label: "Другое",            Icon: QuestionMarkIcon },
];

export default function TicketCategorySelect({ value, onChange }) {
  return (
    <div className="sup-cat-grid">
      {CATEGORIES.map((c) => {
        const Icon = c.Icon;
        const active = value === c.id;
        return (
          <button
            key={c.id}
            type="button"
            className={`sup-cat-cell ${active ? "is-active" : ""}`}
            onClick={() => onChange(c.id)}
          >
            <span className="sup-cat-cell__ico">
              <Icon size={24} />
            </span>
            <span>{c.label}</span>
          </button>
        );
      })}
    </div>
  );
}
